import { OrganizationFeatureDto } from "../../common/service/server/dto/OrganizationFeatureDto";

export const organizationFeatureIsEnabled = (
  featureName: string,
  organizationFeatures: OrganizationFeatureDto[] = [],
): boolean => {
  return organizationFeatures.filter((f) => f.name === featureName && f.enabled).length >= 1;
};

/**
 * Check if the current environment is our own TrueVault staging environment. This is intended for small UI differences,
 * like showing a different URL in developer instructions, for our own convenience.
 */
export const isStagingEnvironment = (): boolean => {
  return window.location.href.includes("truevaultstaging.com");
};
